import * as t from 'io-ts';
import { BasePutRequest } from 'acscp/api/requests/core/basePutRequest';
import { Authentication } from 'acscp/api/requests/core/baseRequest';

export class NotificationMarkAsReadRequest extends BasePutRequest<undefined> {
    constructor(public notificationIds: string[]) {
        super('/notifications/markAsRead', {}, {notificationIds}, t.undefined, Authentication.SharingToken);
    }
}
